import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-component',
  imports: [],
  templateUrl: './privacy-policy-component.html',
  styleUrl: './privacy-policy-component.css'
})
export class PrivacyPolicyComponent {

}
